import { memo } from "react";
import * as Styled from "./style";
import { MenuNameWithNewTag } from "~/components/blocks/layout/global-navi/desktop/left/dmm-service/navi-list/navi-item/menu-name-with-new-tag";
import { sendTrackingClickCommon } from "~/lib/tracking/events";

type ListItemProps = {
  /** リストに表示するテキスト */
  text: string;
  /** リストに表示する アイコン画像 */
  src: string;
  /** 遷移先リンク */
  href?: string;
  /** 経由元を識別する順序 */
  viaViewRank: number;
  /** 経由元を識別するID */
  viaTargetId: string;
  /** Newアイコンの表示・非表示フラグ */
  isNew: boolean;
  /** リストアイテム押下時のイベントハンドラ */
  onItemPressed?: () => void;
};

export const _NaviItem = ({ text, src, href, viaViewRank, viaTargetId, isNew, onItemPressed }: ListItemProps) => {
  return (
    <Styled.LIList>
      {href !== undefined ? (
        <Styled.AnchorItem
          href={href}
          onClick={() => sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId, viaViewRank })}
        >
          <Styled.ImageIcon src={src} width="22px" height="22px" alt="" />
          <Styled.SpanMenuNameWithNewTagWrapper>
            <MenuNameWithNewTag menuName={text} isNew={isNew} />
          </Styled.SpanMenuNameWithNewTagWrapper>
        </Styled.AnchorItem>
      ) : (
        <Styled.ButtonItem
          type="button"
          name="openMoreButton"
          aria-label="openMoreButton"
          onClick={() => onItemPressed && onItemPressed()}
        >
          <Styled.ImageIcon src={src} width="22px" height="22px" alt="" />
          <Styled.SpanMenuNameWithNewTagWrapper>
            <MenuNameWithNewTag menuName={text} isNew={isNew} />
          </Styled.SpanMenuNameWithNewTagWrapper>
        </Styled.ButtonItem>
      )}
    </Styled.LIList>
  );
};

export const NaviItem = memo(_NaviItem);
